/* unplugin-vue-components disabled */import script from "./InfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=ts"

import "./InfoCard.vue?vue&type=style&index=0&id=bcdad6fe&lang=less"

const __exports__ = script;

export default __exports__